import ModalLink from 'components/ModalLink'
import { memo } from 'react'
import {
  DoneButton,
  SuccessTipContent,
  SuccessTipReiceivedAmount,
  SuccessTipReiceivedLabel,
  SuccessTipText,
} from './style'
import { atom, useAtom } from 'jotai'
import { ReactComponent as SvgDone } from './assets/done.svg'
import { useConvertTokenConfig } from 'store/convert/hooks'
import { toFixed } from 'utils/number'

export const ConvertResult = atom({
  show: false,
  value: '',
  symbol: '',
})

export const ConvertSuccessTip = memo(() => {
  const [result, setRes] = useAtom(ConvertResult)
  const { show, value, symbol } = result
  const convertTokens = useConvertTokenConfig()

  const closeHandler = () => {
    setRes({
      show: false,
      value: '',
      symbol: '',
    })
  }

  const fixedValue = (symbol: string) => {
    const scale = convertTokens.filter((d) => d.name === symbol)?.[0]?.scale
    return toFixed(value, scale)
  }

  return (
    <ModalLink
      isIn={show}
      width="435px"
      hideCloseBtn={true}
      onClose={closeHandler}
      style={{
        backgroundColor: '#1E2329',
      }}
    >
      <SuccessTipContent>
        <SvgDone />

        <SuccessTipText>Convert Successfully</SuccessTipText>
        <SuccessTipReiceivedLabel>You have reiceived</SuccessTipReiceivedLabel>
        <SuccessTipReiceivedAmount>
          {fixedValue(symbol)} {symbol}
        </SuccessTipReiceivedAmount>
        <DoneButton variant="contained" onClick={closeHandler}>
          Done
        </DoneButton>
      </SuccessTipContent>
    </ModalLink>
  )
})
